import { z } from "zod";
import { ChecklistReviewSchema } from "@remi/checklist-schema/types";
import { ItelDamageExtentSchema } from "@remi/enums/itel-damage-extent";
import { PhotoReviewAttemptTypeSchema } from "@remi/enums/photo-review-attempt-type";
import { RoofMaterialSchema } from "@remi/enums/roof-material";
import { TaskType } from "@remi/enums/task-type";

export const ConfirmProjectIsRTITaskAttemptSchema = z.object({
  type: z.literal(TaskType.CONFIRM_PROJECT_IS_RTI),
  attemptType: PhotoReviewAttemptTypeSchema,
  requestDescription: z.string().optional(),
  roofMaterial: RoofMaterialSchema.optional(),
  /** Submission ID when using the new checklist flow */
  submissionId: z.string().optional(),
  /** Review data when using the new checklist flow */
  review: ChecklistReviewSchema.optional(),
  /** The checklist question ID this action applies to */
  questionId: z.string().optional(),
  roofDetermination: z
    .object({
      damaged: z.boolean(),
      threeTab: z.boolean().optional(),
      extent: ItelDamageExtentSchema.optional(),
    })
    .refine((data) => data.damaged || (data.threeTab === undefined && data.extent === undefined), {
      message: "threeTab and extent must not be set when damaged is false",
      path: ["threeTab"],
    })
    .optional(),
  sidingDetermination: z
    .object({
      damaged: z.boolean(),
      materialIsEligible: z.boolean().optional(),
    })
    .optional(),
});

export type ConfirmProjectIsRTITaskAttempt = z.infer<typeof ConfirmProjectIsRTITaskAttemptSchema>;
